module.exports = __webpack_public_path__ + "media/img/corporate/company_profile_1-d2a0fa7e423c4bb70692e3728b38b62f.svg";